<template>
  <header
    class="header"
    :class="{
      'header-hide': hideHeader,
      'header-detail': isDetail,
      'header-popup': isPopup,
      'header-sticky': isStickyTab,
      'header-over': isOver
    }"
  >
    <div class="header-inner">
      <h1>
        <router-link :to="{name: 'Main', params : { 'locale' : locale === 'en' ? 'en' : undefined }}" @click.native="goMain">
          <logo-en v-if="locale === 'en'" />
          <logo v-else />
          <span hidden>{{ $t('woowabrothers') }}</span>
        </router-link>
      </h1>

      <button
        v-if="isDetail"
        type="button"
        class="header-before"
        :title="$t('back')"
        @click="goBack"
      >
        <icon-arrow />
      </button>

      <button
        v-if="isPopup"
        type="button"
        class="header-close"
        :title="$t('close')"
        @click="goBack"
      >
        <icon-close />
      </button>

      <button
        v-else
        type="button"
        class="header-open"
        @click="onHeaderOpen"
      >
        <icon-menu />
      </button>

      <div class="header-nav" :class="{'header-nav-open': isHeaderOpen}">
        <div class="header-nav-top">
          <router-link :to="{name: 'Main', params : { 'locale' : locale === 'en' ? 'en' : undefined }}" class="header-nav-logo" @click.native="goTop">
            <logo-en v-if="locale === 'en'" />
            <logo v-else />
          </router-link>
          <button class="header-nav-close" type="button" @click="onHeaderOpen">
            <icon-close />
          </button>
        </div>

        <nav class="header-global">
          <ul class="header-global-nav">
            <li @mouseenter="onHeaderOver" @mouseleave="onHeaderOut">
              <strong>
                <router-link :to="{name: 'Company', params : { 'locale' : locale === 'en' ? 'en' : undefined }}" @click.native="isHeaderClose">
                  {{ $t('menuCompany.company') }}
                </router-link>
                <button type="button" @click="onToggle">
                  <icon-chevron-down />
                </button>
              </strong>
              <div class="header-global-sub">
                <ul>
                  <li>
                    <router-link
                      :to="{name: 'Company', params : { child: 'culture', 'locale' : locale === 'en' ? 'en' : undefined }}"
                      @click.native="goPageAnchor"
                    >
                      {{ $t('menuCompany.woowaCulture') }}
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      :to="{name: 'Company', params : { child: 'history', 'locale' : locale === 'en' ? 'en' : undefined }}"
                      @click.native="goPageAnchor"
                    >
                      {{ $t('menuCompany.history') }}
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      :to="{name: 'Company', params : { child: 'ethical', 'locale' : locale === 'en' ? 'en' : undefined }}"
                      @click.native="goPageAnchor"
                    >
                      {{ $t('menuCompany.ethicalManagement') }}
                    </router-link>
                  </li>
                </ul>
              </div>
            </li>
            <li @mouseenter="onHeaderOver" @mouseleave="onHeaderOut">
              <strong>
                <router-link :to="{name: 'Service', params : { 'locale' : locale === 'en' ? 'en' : undefined }}" @click.native="isHeaderClose">
                  {{ $t('menuService.service') }}
                </router-link>
                <button type="button" @click="onToggle">
                  <icon-chevron-down />
                </button>
              </strong>
              <div class="header-global-sub">
                <ul>
                  <li>
                    <router-link
                      :to="{name: 'Service', params : { child: 'order', 'locale' : locale === 'en' ? 'en' : undefined }}"
                      @click.native="goPageAnchor"
                    >
                      {{ $t('menuService.deliveryTakeout') }}
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      :to="{name: 'Service', params : { child: 'commerce', 'locale' : locale === 'en' ? 'en' : undefined }}"
                      @click.native="goPageAnchor"
                    >
                      {{ $t('menuService.commerce') }}
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      :to="{name: 'Service', params : { child: 'ceo', 'locale' : locale === 'en' ? 'en' : undefined }}"
                      @click.native="goPageAnchor"
                    >
                      {{ $t('menuService.vendorsRiders') }}
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      :to="{name: 'Service', params : { child: 'culture', 'locale' : locale === 'en' ? 'en' : undefined }}"
                      @click.native="goPageAnchor"
                    >
                      {{ $t('menuService.culture') }}
                    </router-link>
                  </li>
                </ul>
              </div>
            </li>
            <li @mouseenter="onHeaderOver" @mouseleave="onHeaderOut">
              <strong>
                <router-link
                  :to="{name: 'Writing', params : { 'locale' : locale === 'en' ? 'en' : undefined } }"
                  @click.native="goTop"
                >
                  {{ $t('menuTogetherValue') }}
                </router-link>
                <button type="button" @click="onToggle">
                  <icon-chevron-down />
                </button>
              </strong>
              <div v-if="!!writingCategories" class="header-global-sub">
                <ul>
                  <template v-for="(item, key) in writingCategories">
                    <li v-if="item.categorySeq !== 0" :key="key">
                      <router-link
                        :to="{name: 'Writing', params : { 'locale' : locale === 'en' ? 'en' : undefined , category : item.categorySeq}, query : {page : 1, offset: true}}"
                        @click.native="goPageAnchor"
                      >
                        {{ locale === 'en' ? item.categoryEnglishName : item.categoryKoreaName }}
                      </router-link>
                    </li>
                  </template>
                </ul>
              </div>
            </li>
            <li @mouseenter="onHeaderOver" @mouseleave="onHeaderOut">
              <strong>
                <router-link
                  :to="{name: 'Newsroom', params : { 'locale' : locale === 'en' ? 'en' : undefined}, query : {page : 1}}"
                  @click.native="goTop"
                >
                  {{ $t('menuNewsroom.newsroom') }}
                </router-link>
                <button type="button" @click="onToggle">
                  <icon-chevron-down />
                </button>
              </strong>
              <div class="header-global-sub">
                <ul>
                  <li>
                    <router-link
                      :to="{name: 'NewsroomReport', params : { 'locale' : locale === 'en' ? 'en' : undefined}, query : {page : 1, offset: true}}"
                      @click.native="goPageAnchor"
                    >
                      {{ $t('menuNewsroom.press') }}
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      :to="{name: 'NewsroomMedia', params : { 'locale' : locale === 'en' ? 'en' : undefined}, query : {page : 1, offset: true}}"
                      @click.native="goPageAnchor"
                    >
                      {{ $t('menuNewsroom.release') }}
                    </router-link>
                  </li>
                  <li>
                    <router-link
                      :to="{name: 'NewsroomFact', params : { 'locale' : locale === 'en' ? 'en' : undefined}, query : {page : 1, offset: true}}"
                      @click.native="goPageAnchor"
                    >
                      {{ $t('menuNewsroom.factCheck') }}
                    </router-link>
                  </li>
                </ul>
              </div>
            </li>
            <li>
              <strong>
                <router-link :to="{name: 'Fonts', params : { 'locale' : locale === 'en' ? 'en' : undefined }}" @click.native="isHeaderClose">
                  {{ $t('menuFonts') }}
                  <span class="header-global-lol">
                    <span>
                      <i
                        v-for="key in 5"
                        :key="key"
                        ref="lol"
                        hidden
                      >ㅋ</i>
                    </span>
                  </span>
                </router-link>
              </strong>
            </li>
          </ul>
        </nav>
        <nav class="header-family">
          <template v-for="(item, key) in siteConnectionLevelFirst">
            <a
              :key="`level1_${key}`"
              :href="item.connectionSiteUrl"
              class="first"
              target="_blank"
            >
              <span>{{ locale === 'ko' ? item.connectionSiteKoreaName : item.connectionSiteEnglishName }}</span>
              <icon-blank />
            </a>
          </template>
          <template v-for="(item, key) in siteConnectionLevelSecond">
            <a :key="`level2_${key}`" :href="item.connectionSiteUrl" target="_blank">
              <span>{{ locale === 'ko' ? item.connectionSiteKoreaName : item.connectionSiteEnglishName }}</span>
              <icon-blank />
            </a>
          </template>
        </nav>

        <div class="header-nav-foot">
          <ul class="header-other">
            <li>
              <router-link :to="{name:'Notice', params: {locale: $route.params.locale}, query: {page: 1}}" @click.native="isHeaderClose">{{ $t('menuNotices') }}</router-link>
            </li>
            <li>
              <router-link :to="{name:'Place', params: {locale: $route.params.locale}}" @click.native="isHeaderClose">{{ $t('menuLocation') }}</router-link>
            </li>
          </ul>

          <ul class="header-lang">
            <li>
              <button type="button" :disabled="locale === 'ko'" @click="onChangeTranslate('ko')">한</button>
            </li>
            <li>
              <button type="button" :disabled="locale === 'en'" @click="onChangeTranslate('en')">A</button>
            </li>
          </ul>
        </div>
      </div>

      <i class="header-dim" />
    </div>
  </header>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { getLang } from '@/util'
import menu from '@/mixins/menu'
import { throttle } from 'lodash'

export default {
  components: {
    logo: () => import('@/static/svg/logo.svg'),
    logoEn: () => import('@/static/svg/logo-en.svg'),
    iconBlank: () => import('@/static/svg/blank.svg'),
    iconMenu: () => import('@/static/svg/menu.svg'),
    iconClose: () => import('@/static/svg/close.svg'),
    iconChevronDown: () => import('@/static/svg/chevron-down.svg'),
    iconArrow: () => import('@/static/svg/arrow.svg')
  },
  mixins: [
      menu
  ],
  data () {
    return {
      isStickyTab: false,
      stickyPosition: false,
      hideHeader: false,
      scrollOffset: null,
      onDebounceHandler: null,
      isOver: false,
      lolTimeout: null,
      offsetTop: 0
    }
  },
  computed: {
    ...mapGetters({
      locale: 'locale/GET_LOCALE',
      siteConnectionLevelFirst: 'site/siteConnectionLevelFirst',
      siteConnectionLevelSecond: 'site/siteConnectionLevelSecond',
      writingCategories: 'categories/get_writing_categories'
    }),
    isDetail () {
      const details = ['writingDetail', 'newsroomReportDetail', 'newsroomFactDetail', 'NoticeDetail', 'NewsroomSearch']

      return details.includes(this.$route.name)
    },
    isPopup () {
      const popups = ['FontsLicense']

      return popups.includes(this.$route.name)
    }
  },
  watch: {
    $route () {
      this.isHeaderOpen = false
      this.isStickyTab = false
      document.documentElement.classList.remove('header-nav-show')
    },
    '$route.params.child' (v) {
      if (v) {
        this.goSubTab()
      }
    },
    '$route.params.locale' () {
      document.documentElement.scrollTop = 0
    },
    '$route.hash' (v) {
      if (v) {
        this.goSubTab()
      }
    },
    // isHeaderOpen (v) {
    //   console.log('------------------')
    // }
    // writingCategories (v) {
    //   console.log('ch', v)
    // }
  },
  mounted () {
    this.$root.$on('tab-sticky', this.onTabSticky)
    this.onDebounceHandler = throttle(this.onScroll, 15)

    // window.addEventListener('load', this.onScroll)
    window.addEventListener('scroll', this.onDebounceHandler)

    window.addEventListener('resize', () => {
      document.documentElement.classList.remove('header-nav-show')
      this.isHeaderOpen = false
    })

    // this.onScroll()
  },
  methods: {
    ...mapActions({
      localeChange: 'locale/localeChange'
    }),
    goBack () {
      // TODO: route 다시 고민
      this.$router.go(-1)
    },
    onTabSticky (hide) {
      this.isStickyTab = hide
    },
    onHeaderOpen () {
      this.isHeaderOpen = !this.isHeaderOpen
      if (this.isHeaderOpen) {
        this.offsetTop = window.scrollY || window.pageYOffset
      }
      document.documentElement.classList.toggle('header-nav-show', this.isHeaderOpen)

      if (!this.isHeaderOpen) {
        this.onHeaderClose()
      }
      this.setLol()
    },
    onHeaderClose () {
      document.documentElement.scrollTop = this.offsetTop
      const openNav = document.querySelectorAll('.header-global-active')
      Array.from(openNav).forEach(item => {
        item.classList.remove('header-global-active')
      })
    },
    onChangeTranslate (lang) {
      window.localStorage.setItem('lang', lang)

      this.localeChange({
        lang,
        query: this.$route.query
      })
      getLang(this.locale, 'global')
    },
    onToggle (e) {
      const $li = e.target.closest('li')

      $li.classList.toggle('header-global-active')
    },
    mouseOver (e) {
    },
    onScroll () {
      const offset = window.scrollY || window.pageYOffset
      const offsetGap = 2

      if (offset <= 0) {
        this.$root.$emit('header-show', true)
        this.hideHeader = false
        return
      }

      if (this.scrollOffset - offset < offsetGap * -1) {
        this.$root.$emit('header-show', false)
        this.hideHeader = true
      } else if (this.scrollOffset - offset > offsetGap) {
        this.$root.$emit('header-show', true)
        this.hideHeader = false
      }

      this.scrollOffset = offset

      // requestAnimationFrame(this.onScroll)
    },
    onHeaderOver (e) {
      if (document.documentElement.offsetWidth < 751) {
        return false
      }
      this.isOver = true

      // hover한 menu에 header-global-sub가 있으면
      if (e.target.children[1]) {
        // hover한 menu에 li를 모두 담아서.
        const roll = e.target.children[1].children[0].children

        // router.replace로 active된 el 찾기.
        let hasClass = true
        roll.forEach(v => {
          if (v.children[0].classList.contains('router-link-active')) {
            hasClass = false
          }
        })

        if (hasClass) {
          // default
          // header-global-sub에는 hover되어있지만 li에 hover되어 있지않다면  first li에 active
          e.target.children[1].children[0].children[0].children[0].classList.add('active')

          // header-global-sub의 ul영역을 벗어난경우.
          // header-global-sub에는 hover되어있지만 li에 hover되어 있지않다면  first li에 active
          e.target.children[1].children[0].addEventListener('mouseleave', function () {
            e.target.children[1].children[0].children[0].children[0].classList.add('active')
          })
        }

        // 각 li에 hover할때와 out할때 active 클래스 추가/제거.
        for (let i = 0; i < roll.length; i++) {
          roll[i].addEventListener('mouseenter', function () {
            if (i !== 0) {
              roll[0].children[0].classList.remove('active')
            }
            roll[i].children[0].classList.add('active')
          })

          roll[i].addEventListener('mouseleave', function () {
            roll[i].children[0].classList.remove('active')
          })
        }
      }
    },
    onHeaderOut (e) {
      if (document.documentElement.offsetWidth < 751) {
        return false
      }
      this.isOver = false
    },
    goSubTab () {
      setTimeout(() => {
        this.hideHeader = true
      }, 10)
    },
    goMain () {
      if (this.$route.name === 'Main') {
        window.location.reload()
      }
    },
    setLol () {
      let lolIndex = 0
      let lolMax = 3
      let lolDir = 'up'

      const lol = () => {
        if (!this.isHeaderOpen) {
          return false
        }

        this.$refs.lol.forEach((item, i) => {
          if (i >= lolIndex) {
            item.setAttribute('hidden', true)
          } else {
            item.removeAttribute('hidden')
          }
        })

        if (lolIndex === 5) {
          return
        }
        if (lolIndex <= lolMax && lolDir === 'down') {
          if (lolIndex === 0) {
            lolDir = 'up'
            lolMax = 5
          }
          lolIndex--
        }
        if (lolIndex < lolMax && lolDir === 'up') {
          lolIndex++
          if (lolIndex === lolMax) {
            lolDir = 'down'
          }
        }

        setTimeout(lol, 300)
      }

      this.lolTimeout = setTimeout(lol, 300)
    }
  }
}
</script>
